import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { g as getTranslationComponent } from '../../i18n/CloseButtonTranslation/index-OLhmGeVs.js';
import { I as IntlProvider } from '../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-CX9yP88S-B6OFY9Vv.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BGx4v_Uj-CJNeXUZQ.js';
import { I as Icon } from '../../Icon/Icon-CqA2URu0.js';
import { t as times } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { T as TextButton } from '../TextButton/TextButton-C4PCLtT7.js';

const TextButtonWrapper = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30061128__sc-hg0t2u-0"
})(["background:transparent;color:", ";font-size:", ";:hover{color:", ";cursor:pointer;}"], ({
  theme
}) => theme.button.close.color, ({
  theme
}) => theme.typography.size.medium, ({
  theme
}) => theme.button.close.colorHover);
const CloseButtonContent = ({
  className,
  onClick,
  label,
  size = 'sm',
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(TextButtonWrapper, _extends({}, rest, {
    className: className,
    tabIndex: 0,
    onClick: onClick,
    "aria-label": label || formatMessage({
      id: 'close_button_label'
    }),
    type: "button"
  }), /*#__PURE__*/React__default.createElement(Icon, {
    type: times,
    size: size
  }));
};
const CloseButton = ({
  locale,
  onError,
  fallback,
  onReset,
  ...rest
}) => {
  const translations = getTranslationComponent(locale);
  return /*#__PURE__*/React__default.createElement(IntlProvider, {
    onError: onError,
    resetKey: locale,
    fallback: fallback,
    onReset: onReset,
    translations: translations
  }, /*#__PURE__*/React__default.createElement(CloseButtonContent, rest));
};
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = {
  className: PT.string,
  label: PT.string,
  onClick: PT.func,
  size: PT.oneOf(['sm', 'lg']),
  locale: PT.string
};
CloseButton.defaultProps = {
  className: '',
  label: undefined,
  onClick: () => undefined,
  size: 'sm',
  locale: 'en-US'
};

export { CloseButton as C };
//# sourceMappingURL=CloseButton-D09ugBKZ.js.map
